import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

const NoteIcon = (props) => (
  <SvgIcon {...props}>
    <polyline fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
      17.255,16.055 17.255,21 2.727,21 2.727,4 17.255,4 17.255,8.018 "/>
    <polygon fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
      21.273,8.945 12.309,17.909 9.836,17.909 9.836,15.436 18.8,6.473 "/>
  </SvgIcon>
);

export default NoteIcon;



// WEBPACK FOOTER //
// ./src/icons/NoteIcon.jsx